module.exports = __webpack_public_path__ + "static/media/confirmar respuestas_bEN.296cb05f.svg";